/**
 * Shallow-merge property object for feature updates. `null` in the patch removes the key
 * (unset custom fields such as angle), matching API `PUT` merge behaviour.
 */
export function mergePropertyPatch(
  prev: Record<string, unknown>,
  patch: Record<string, unknown>,
): Record<string, unknown> {
  const next: Record<string, unknown> = { ...prev };
  for (const [k, v] of Object.entries(patch)) {
    if (v === null) {
      delete next[k];
    } else {
      next[k] = v;
    }
  }
  return next;
}
